'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { ServicesList } from '@src/components/common/services-list/services-list';
import { Link } from '@mui/material';
import { cn } from '@src/utils/ui';

export const LatestListingsContent = ({ items, userID }) => (
    <div className="section-latest-listings mx-auto tw-clear-both">
        <div
            className={cn(
                'latest-listings-title tw-flex tw-flex-col tw-w-full tw-h-[156px]',
                'tw-pt-[60px] tw-pb-[24px] tw-px-[16px] tw-gap-[20px]',
                'tw-text-center tw-justify-center',
                'md:tw-px-[32px]',
                'lg:tw-px-[48px]',
                'xl:tw-px-[64px]',
                '2xl:tw-px-[160px]'
            )}
        >
            <span className="tw-text-[24px] tw-font-bold tw-text-primary-500">Latest Tasks</span>
            <div className="divider tw-w-[70px] tw-h-[4px] tw-bg-[#EE3124] tw-mx-auto" />
        </div>

        <ServicesList hasFullScreenWidth services={items} className="latest-listings-list" userID={userID} />

        <div className="latest-listings-footer tw-flex tw-justify-center tw-w-full tw-h-[176px] tw-pt-[60px] tw-pb-[60px] tw-gap-[10px]">
            <Link
                href="/search"
                className="tw-flex tw-items-center tw-justify-center tw-w-[125px] tw-h-[40px] tw-border-[3px] tw-border-primary-500 tw-no-underline tw-text-primary-500 hover:tw-bg-black hover:tw-text-white tw-transition-all tw-duration-[700ms] tw-ease-linear"
            >
                <span className="tw-flex tw-items-center tw-gap-2 tw-font-[700] tw-text-[14px] tw-leading-[35px] tw-tracking-[0%] tw-text-center tw-align-middle">
                    View More <i className="fa fa-angle-right" />
                </span>
            </Link>
        </div>
    </div>
);

LatestListingsContent.propTypes = {
    items: PropTypes.array.isRequired,
    userID: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])])
};
